"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCamelCase = void 0;
/**
 * Converts a string to camel case.
 * @param {string} name
 * @returns {string}
 */
function getCamelCase(name) {
    return name.replace(/[ -][a-z]/g, (string) => string[1].toUpperCase());
}
exports.getCamelCase = getCamelCase;
//# sourceMappingURL=getCamelCase.js.map